import React from 'react';
import PropTypes from 'prop-types';

import { Link, OpenInNewIcon, Text } from './GradeNow.styled';

import { Assignment as AssignmentType } from '$variables/types';

import { providers } from '$variables/constants';
import { buildHandinAssignmentURL } from '$utils/buildHandinURLs';
import { buildSSAAssignmentURL } from '$utils/buildSSAURLs';

const { TURNITIN, MANUAL, HAND_IN } = providers;

const getLinkProps = ({
  provider,
  space,
  externalId,
  id,
  launchTurnitinAssignment,
}) => {
  if (provider === MANUAL) {
    return { href: buildSSAAssignmentURL({ space, assignmentId: id }) };
  }

  if (provider === TURNITIN) {
    return {
      onClick: () => launchTurnitinAssignment(id),
    };
  }

  if (provider === HAND_IN) {
    return {
      href: buildHandinAssignmentURL({ space, externalId }),
    };
  }

  // unhandled providers
  return null;
};

const GradeNow = ({
  assignment: { provider, space, id, externalId },
  launchTurnitinAssignment,
}) => {
  const linkProps = getLinkProps({
    provider,
    space,
    id,
    externalId,
    launchTurnitinAssignment,
  });

  if (!linkProps) {
    return null;
  }

  return (
    <Link
      {...linkProps}
      target="_blank"
      aria-label="Open link in a new tab"
      data-testid="grade-now"
    >
      <Text>Grade now</Text>
      <OpenInNewIcon />
    </Link>
  );
};

GradeNow.propTypes = {
  assignment: AssignmentType.isRequired,
  launchTurnitinAssignment: PropTypes.func.isRequired,
};

export default GradeNow;
